<template>
  <v-card
    outlined
    class="app-card mt-6"
  >
    <v-card-title class="app-card-title mb-0">
      Menu
    </v-card-title>
    <v-card-text class="app-card-content pl-0 pr-0 pb-0">
      <v-list
        nav
        dense
      >
        <v-list-item-group color="primary">
          <v-list-item
            :to="{ name: 'criar-solicitacao' }"
            exact
          >
            <v-list-item-icon>
              <v-icon v-text="'library_add'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="'Criar Solicitação'"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :to="{ name: 'solicitacoes' }"
            exact
          >
            <v-list-item-icon>
              <v-icon v-text="'account_box'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Solicitações'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item
           :to="{name: 'lotes'}"
            exact
          >
            <v-list-item-icon>
              <v-icon v-text="'switch_account'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Lotes'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="logout()"
            exact
          >
            <v-list-item-icon>
                <v-icon right>fa-arrow-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Sair'" />
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import AuthService from "@/services/sie-pedidos/auth.service";
export default {
  name: "Menu",
  methods: {
    logout(){
      AuthService.logout( true)
      AuthService.globalStore("success", "Saiu com sucesso!")
    }
  }
}
</script>
<style lang="scss" scoped>
.help {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
  color: #333;
  i {
    color: #333;
  }
  span {
    margin-left: -16px;
  }
}
</style>
